export default __webpack_public_path__ + "26bfa72c126dc3341e7a6b577dce280b.png";